/**
 * @generated SignedSource<<2e5621870ab8304b4f1b6e4eed5911b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSourceInput = {
  clientMutationId?: string | null;
  name: string;
  description: string;
  tag: string;
};
export type SourceCreateFormContainer_Mutation$variables = {
  input: CreateSourceInput;
};
export type SourceCreateFormContainer_MutationVariables = SourceCreateFormContainer_Mutation$variables;
export type SourceCreateFormContainer_Mutation$data = {
  readonly createSource: {
    readonly source: {
      readonly id: string;
      readonly name: string;
      readonly description: string;
      readonly tag: string;
      readonly slug: string;
    } | null;
  } | null;
};
export type SourceCreateFormContainer_MutationResponse = SourceCreateFormContainer_Mutation$data;
export type SourceCreateFormContainer_Mutation = {
  variables: SourceCreateFormContainer_MutationVariables;
  response: SourceCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSourcePayload",
    "kind": "LinkedField",
    "name": "createSource",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceCreateFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceCreateFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4a7549972b07a923d1b412acc2a76054",
    "id": null,
    "metadata": {},
    "name": "SourceCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation SourceCreateFormContainer_Mutation(\n  $input: CreateSourceInput!\n) {\n  createSource(input: $input) {\n    source {\n      id\n      name\n      description\n      tag\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80f1a813f1f8edf802fc802cf259d583";

export default node;
